import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Loading from 'components/Loading';
import useDialog from 'components/Dialog/useDialog';
import { ROUTE_PATH } from 'routes';
import {
  Navigate, useNavigate, useParams, useSearchParams,
} from 'react-router-dom';
import INVESTMENT_ASSET from 'constants/investmentAsset';
import { getInvestmentAsset } from 'modules/investmentAssets/repository';
import { getFund } from '../modules/actions';
import OnboardingSteps from './OnboardingSteps';
import createOnboardingConfig from '../config/onboardingConfig';
import './styles.scss';

function OnboardingIntro(props) {
  const {
    literals,
    literalsCommon,
    user,
    startup,
    fetchCompany,
    platform,
    showLoading,
    embed,
  } = props;

  const { id, type } = useParams();

  const [investmentAsset, setInvestmentAsset] = useState({});
  const [loading, setLoading] = useState(!!id);
  const { dialog } = useDialog();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const onboardingConfig = createOnboardingConfig({
    id,
    user,
    startup,
    investmentAsset,
    showLoading,
    navigate,
    fetchCompany,
    embed,
    dialog,
    literals,
  });

  const fetchInfo = async () => {
    if (id) {
      setLoading(true);
      if (type === 'fund') {
        const response = await getFund(id);
        setInvestmentAsset(response);
      } else if (['company_founder', 'company_guest'].includes(type)) {
        await fetchCompany(id);
      } else {
        const response = await getInvestmentAsset(id);
        setInvestmentAsset(response);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Loading />;
  }

  const onboardingProps = {
    platform,
    literals,
    literalsCommon,
    view: false,
    startups: user.startups,
    onSubmitForm: false,
    answers: false,
    embed,
  };

  const config = INVESTMENT_ASSET.includes(type) ? onboardingConfig.investment : onboardingConfig[type];
  if (config && user?.role?.includes(config.roleCheck)) {
    onboardingProps.view = type;
    onboardingProps.onSubmitForm = config.onFinish;
    onboardingProps.answers = config.getAnswers() || {};
    if (searchParams.get('name') && !onboardingProps?.answers?.name) {
      onboardingProps.answers.name = searchParams.get('name');
    }
  }

  if (onboardingProps.view) {
    return <OnboardingSteps {...onboardingProps} id={id} />;
  }

  return <Navigate to={ROUTE_PATH.PREHOME} />;
}

OnboardingIntro.propTypes = {
  literals: PropTypes.object.isRequired,
  literalsCommon: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  fetchCompany: PropTypes.func.isRequired,
  startup: PropTypes.object.isRequired,
  platform: PropTypes.object.isRequired,
  showLoading: PropTypes.func.isRequired,
  embed: PropTypes.bool,
};

OnboardingIntro.defaultProps = {
  embed: false,
};
export default OnboardingIntro;
